import { formatMoney } from 'utils/formatNumber';

export const formatMoneyToNumber = (value: string | number | undefined = 0) => {
  const numberValue = +value;
  if (!isNaN(numberValue)) return numberValue;

  //remove non-numbers characters
  const cleanedValue = value.toString().replace(/[^0-9.]/g, '');
  const cleanedNumber = +cleanedValue;
  if (!isNaN(cleanedNumber)) return cleanedNumber;

  //remove extra decimals
  const cleanedValue2 = cleanedValue.split('.').slice(0, 2).join('.');
  const cleanedNumber2 = +cleanedValue2;

  return isNaN(cleanedNumber2) ? 0 : cleanedNumber2;
};

export const formatMoneyValue = (value: string | number | undefined = 0) => {
  const cleanValue = formatMoneyToNumber(value as string);
  return formatMoney(+cleanValue);
};
